import React from "react";

/**
 * Big touch-friendly choice card used across the Compass flow.
 * - accent: "blue" | "green" | "neutral"
 * - Icon: phosphor icon component (optional)
 */
export default function BigCard({
  accent = "neutral",
  Icon,
  title,
  description,
  cta,
  onClick,
  selected = false,
  testid,
  small = false,
}) {
  const accentMap = {
    blue:    { bg: "#0055FF", fg: "#FFFFFF" },
    green:   { bg: "#2A9D8F", fg: "#FFFFFF" },
    orange:  { bg: "#F77F00", fg: "#FFFFFF" },
    neutral: { bg: "transparent", fg: "hsl(var(--foreground))" },
  };
  const style = accentMap[accent] || accentMap.neutral;

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`w-full text-left bg-surface border-2 border-foreground p-5 md:p-6 flex flex-col gap-3 transition-transform active:translate-x-[2px] active:translate-y-[2px] hover:-translate-x-[2px] hover:-translate-y-[2px] ${
        selected ? "shadow-[6px_6px_0_0_hsl(var(--foreground))]" : "shadow-[4px_4px_0_0_hsl(var(--foreground))] hover:shadow-[6px_6px_0_0_hsl(var(--foreground))]"
      }`}
    >
      {Icon && (
        <div
          className="w-12 h-12 flex items-center justify-center border-2 border-foreground"
          style={{ background: style.bg, color: style.fg }}
        >
          <Icon size={22} weight="bold" />
        </div>
      )}
      <div>
        <div className={`display ${small ? "text-xl" : "text-2xl md:text-3xl"} leading-tight`}>{title}</div>
        {description && (
          <p className={`mt-2 text-sm text-muted-foreground leading-relaxed`}>{description}</p>
        )}
      </div>
      {cta && (
        <div
          className="mt-1 self-start px-4 py-2 border-2 border-foreground label-mono"
          style={{ background: style.bg, color: style.fg }}
        >
          {cta}
        </div>
      )}
    </button>
  );
}
